import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import mockImage from '../OrgImages/reptestimonialmock.svg';
import stars from '../OrgImages/stars.svg';

const CANVAS_W = 640;
const CANVAS_H = 660;

export const OrgFirstChallengeShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'contain');

  return (
    <section
      ref={sectionRef}
      className='relative h-full w-full overflow-hidden bg-gradient-to-t from-secondary-brand-50 from-[23%] to-secondary-brand-25 to-[95%]'
    >
      <div className='flex h-full w-full items-end justify-end'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <p
              className='absolute m-0 text-display-sm font-medium text-gray-800'
              style={{ top: 80, left: 60, width: 540 }}
            >
              If you have a real challenge but<br/>not the resources to solve it,
              don't wait. There are incredible people<br/>out there who want
              to help&mdash;MovingWorlds makes it possible<br/>to find them.
            </p>

            <p
              className='absolute m-0 text-lg font-semibold text-gray-800'
              style={{ top: 370, left: 60 }}
            >
              &mdash; Margaret Yebei
            </p>

            <img
              src={stars}
              alt=''
              className='absolute'
              style={{ top: 376, right: 60, height: 20 }}
            />

            <p
              className='absolute m-0 text-base font-medium text-gray-450'
              style={{ top: 402, left: 60 }}
            >
              Head of Partnerships &amp; Program Ops, EldoHub
            </p>

            <img
              src={mockImage}
              alt=''
              className='absolute'
              style={{ bottom: 0, right: 0, width: 580 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
